import { withAppInsights } from '@exxonmobil/uit-uda-ui-components-lib';
import { api } from 'helpers/api';
import {
  ApiServiceFunctionParams,
  createApiHook
} from 'helpers/apiResponseStateUpdate';
import {
  AssociateCompanyToWorkCenterPayload,
  WorkCenter
} from 'models/workcenters';

const { REACT_APP_WORKCENTERS_API_BASE_URL } = process.env;

const resourceLocation = {
  collectionName: 'uda-workcenters',
  resourceId: ''
};

const cacheOptions = {
  disableCache: true
};

export type GetWorkCentersStateDataType = WorkCenter[];
export type GetWorkCentersParams = {};
export const initWorkCentersData = [];

export const getWorkCenters = async (): Promise<WorkCenter[]> => {
  return withAppInsights(async () =>
    api.get({
      url: `${REACT_APP_WORKCENTERS_API_BASE_URL}`,
      cacheOptions,
      resourceLocation
    })
  );
};

type AssociateCompanyToWorkCenterParams = {
  id: string;
  associateCompanyToWorkCenterPayload: AssociateCompanyToWorkCenterPayload;
};

const initAssociateCompanyToWorkCenter: string[] = [];

export const useAssociateCompanyToWorkCenterApi = createApiHook<
  AssociateCompanyToWorkCenterParams,
  typeof initAssociateCompanyToWorkCenter
>({
  initStateDataValue: initAssociateCompanyToWorkCenter,
  apiServiceFunction: async (
    params: ApiServiceFunctionParams<AssociateCompanyToWorkCenterParams>
  ): Promise<Response> => {
    return withAppInsights(async () => {
      const { id, associateCompanyToWorkCenterPayload } = params;
      const response = await api.patch({
        url: `${REACT_APP_WORKCENTERS_API_BASE_URL}/${id}/companies`,
        body: { value: associateCompanyToWorkCenterPayload },
        resourceLocation
      });
      return response;
    });
  }
});
